import { computed, autorun, decorate, observable, action } from "mobx";
import querystring from "query-string";
import BaseStore from "Core/Stores/BaseStore";

class ViewStore extends BaseStore {
    constructor(rootStore) {
        super(rootStore);

        this.page = window.location.hash;
        this.pageHandlers = [];
        this.notFoundHandler = null;

        this.watchCurrentPage = autorun(() => {
            const page = this.page;
            console.log(`page changed to ${page}`);

            if (window.location.hash !== page) {
                window.location.hash = page;
            }

            this.fetchCurrentPageData();
        });

        window.addEventListener("hashchange", this.handleHashChanged.bind(this));
    }

    get pageName() {
        let pageName = this.page;
        if (this.page) {
            const idx = this.page.indexOf("?");
            if (idx !== -1) {
                pageName = this.page.substring(0, idx);
            }
        }
        if (pageName && pageName.startsWith("#")) {
            pageName = pageName.substring(1);
        }
        return pageName;
    }

    get queryString() {
        return this.parseQueryString(this.page);
    }

    parseQueryString(uri) {
        let queryString = "";
        if (uri) {
            const idx = uri.indexOf("?");
            if (idx !== -1) {
                queryString = uri.substring(idx + 1);
            }
        }
        return queryString;
    }

    get parameters() {
        return querystring.parse(this.queryString);
    }

    get currentPageHandler() {
        let handler = this.pageHandlers.find(
            page => page.pageName === this.pageName
        );
        if (!handler) {
            handler = this.notFoundHandler;
        }
        return handler;
    }

    addPageHandlers(handlers) {
        handlers.forEach(handler => {
            handler.rootStore = this.rootStore;
            this.pageHandlers.push(handler);
        });
    }

    fetchCurrentPageData() {
        const currentPageHandler = this.currentPageHandler;
        if (currentPageHandler && currentPageHandler.fetch) {
            currentPageHandler.fetch(this.parameters);
        } else if (!currentPageHandler) {
            console.warn(" -> no  page handler found");
        }
    }

    changePage(page) {
        if (this.page !== page) {
            this.page = page;
        }
    }

    handleHashChanged() {
        this.changePage(window.location.hash);
    }

    buildUri(page, parameters) {
        page = page || this.pageName;
        let uri = page;
        if (parameters) {
            const pageName = this.getPageName(page);
            const oldqs = this.parseQueryString(page);
            const oldParameters = querystring.parse(oldqs);

            let qs = querystring.stringify({ ...oldParameters, ...parameters });
            if (qs !== "") {
                uri = `${pageName}?${qs}`;
            }
        }
        return `#${uri}`;
    }

    replacePage(page, parameters, fetchAfterPageChange = true) {
        const newPage = this.buildUri(page, parameters);
        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, null, newPage);
        } else {
            console.log("PageHandler: browser doesn't support the history api");
        }

        // make sure we always go to our new page
        this.changePage(newPage, null, fetchAfterPageChange);
    }


    getPageName(page) {
        let pageName = page;
        if (page) {
            const idx = page.indexOf("?");
            if (idx !== -1) {
                pageName = page.substring(0, idx);
            }
        }
        if (pageName && pageName.startsWith("#")) {
            pageName = pageName.substring(1);
        }

        if (pageName && pageName.endsWith("/")) {
            pageName = pageName.substring(0, pageName.length - 1);
        }
        return pageName;
    }
}

decorate(ViewStore, {
    page: observable,
    parameters: computed,
    pageHandlers: observable,
    notFoundHandler: observable,
    pageName: computed,
    queryString: computed,
    currentPageHandler: computed,
    addPageHandlers: action,
    fetchCurrentPageData: action,
    changePage: action
});

export default ViewStore;



// WEBPACK FOOTER //
// ./src/Core/Stores/ViewStore/index.js